// Requires jQuery

(() => {
    $('select').niceSelect();
})();
